import React from 'react';
import PropTypes from 'prop-types';
import {
    Steps,
    Row,
    Typography,
} from 'antd';
import styled from 'styled-components';
import theme from '../../../theme';
import { useMediaQuery } from 'react-responsive';


const propTypes = {
    activeStep: PropTypes.number,
};

const { Step } = Steps;
const { Text } = Typography;

const BOOKING_STEPS = [
    'Select Service',
    'Date & Time',
    'Property Address',
    'Your Details',
    'Addons',
    'Payment & Confirmation',
];

const StyledStepsWrapper = styled.div`
    margin-bottom: ${props => props.theme.unit * 5}px;
    
    @media (max-width: ${props => props.theme.breakpoint.sm}px) {
        margin-bottom: ${props => props.theme.unit * 3}px;
    }
`;

const CustomerBookingFormStepper = ({ activeStep }) => {
    const isLgUp = useMediaQuery({
        maxWidth: theme.breakpoint.lg,
    });

    if (isLgUp) {
        return (
            <StyledStepsWrapper>
                <Row type="flex" justify="end">
                    <Text strong>
                        { `Step: ${activeStep + 1} / ${BOOKING_STEPS.length}` }
                    </Text>
                </Row>
            </StyledStepsWrapper>
        );
    }

    return (
        <StyledStepsWrapper>
            <Steps size="small" current={activeStep} progressDot>
                { BOOKING_STEPS.map(step => <Step title={step} key={step} />) }
            </Steps>
        </StyledStepsWrapper>
    );
};

CustomerBookingFormStepper.propTypes = propTypes;

export default CustomerBookingFormStepper;
